import { useKeyboardShortcut } from '@bestseller-bit/frontend-community.hooks.use-keyboard-shortcut';
import { useCallback } from 'react';

const keyCombo = {
    code: 'KeyV',
    altKey: true,
    description: 'Save changes',
};

export function useSaveShortcut(saveChanges: () => void, disabled: boolean) {
    const callback = useCallback(
        (event: KeyboardEvent) => {
            event.preventDefault();
            event.stopPropagation();
            saveChanges();
        },
        [saveChanges]
    );
    useKeyboardShortcut({
        keyCombo,
        callback,
        disabled: disabled,
    });
}
